/**
 * Pure helper for #186 — group LeadMedia rows by lead_treatment.treatment_name.
 *
 * Extracted to a non-React module so unit tests can import it without pulling
 * in MUI / redux / apiCall (which uses import.meta).
 */

export function groupAttachmentsByTreatment(rows, leadTreatments) {
    const treatments = Array.isArray(leadTreatments) ? leadTreatments : [];
    const treatmentNameById = new Map();
    treatments.forEach((lt) => {
        const id = lt?.id;
        if (id === undefined || id === null) return;
        const name = lt?.treatment?.name
            || lt?.treatment_name
            || lt?.treatment
            || `Treatment ${id}`;
        treatmentNameById.set(String(id), typeof name === 'string' ? name : `Treatment ${id}`);
    });

    const buckets = new Map();
    (rows || []).forEach((r) => {
        if (!r) return;
        const ltId = r.lead_treatment;
        if (ltId === null || ltId === undefined) {
            if (!buckets.has('__general__')) buckets.set('__general__', { key: '__general__', label: 'General', items: [] });
            buckets.get('__general__').items.push(r);
            return;
        }
        const ltKey = String(ltId);
        if (!buckets.has(ltKey)) {
            buckets.set(ltKey, {
                key: ltKey,
                label: treatmentNameById.get(ltKey) || `Treatment ${ltKey}`,
                items: [],
            });
        }
        buckets.get(ltKey).items.push(r);
    });

    const ordered = [];
    treatments.forEach((lt) => {
        const k = String(lt?.id);
        if (buckets.has(k)) ordered.push(buckets.get(k));
    });
    if (buckets.has('__general__')) ordered.push(buckets.get('__general__'));
    buckets.forEach((v, k) => {
        if (k !== '__general__' && !treatments.some((lt) => String(lt?.id) === k)) {
            ordered.push(v);
        }
    });
    return ordered;
}

/** Chatbot photos live on private storage: prefer the signed `private_media` URL over the public `media` one. */
export function getAttachmentUrl(row) {
    return row?.private_media || row?.media || row?.remote_url || null;
}

/** Only https: URLs may be rendered as images/links (blocks javascript:, data:, etc.). */
export function isSafeImageUrl(url) {
    if (typeof url !== 'string') return false;
    try {
        return new URL(url).protocol === 'https:';
    } catch {
        return false;
    }
}

export const isChatbotPhoto = (row) => row?.channel === 'CHATBOT' && isSafeImageUrl(getAttachmentUrl(row));

export function getAttachmentLabel(row) {
    return row?.description || row?.original_filename || row?.media || 'File';
}
